export const dateFormatDbToView = date => {
    return new Date(date).toLocaleDateString();
}